const fileInput = document.querySelector('.feedback__input-file');
const form = document.querySelector('.feedback__form-kuzov');
const fileLabel = document.querySelector('.placeholder-file');
const modalSuccess = document.querySelector('.feedback__form-kuzov__modal-successful');
const policy = document.querySelector('.feedback__kuzovnoy-form__policy');

if (fileInput){
    fileInput.addEventListener('change', function () {
        if (this.files.length > 5) {
            alert('Можно выбрать не более 5 файлов.');
            this.value = '';
            fileLabel.textContent = 'Прикрепите до 5 фото';
        } else if (this.files.length > 0) {
            fileLabel.textContent = `Выбрано файлов: ${this.files.length}`;
        } else {
            fileLabel.textContent = 'Прикрепите до 5 фото';
        }
    });
}

if (form){
    form.addEventListener('submit', function (e) {
        form.style.display = "none";
        policy.style.display = "none";
        modalSuccess.style.display = "flex";
        if(modalSuccess.style.display !== 'none'){
            fileLabel.textContent = 'Прикрепите до 5 фото';
        }
    });
}